import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=9f487a96&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f487a96')) {
      api.createRecord('9f487a96', component.options)
    } else {
      api.reload('9f487a96', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=9f487a96&", function () {
      api.rerender('9f487a96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lw2XC6x8KdmS/JS/cancellationPolicy.vue"
export default component.exports